import type { ComponentProps } from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

/** Translucent homepage panel; the terrain stays faintly visible behind it. */
export function Tile({ className, ...props }: ComponentProps<typeof Card>) {
  return <Card className={cn("bg-card/70 backdrop-blur-sm p-4", className)} {...props} />;
}

/** Section heading for a homepage tile, styled as a small mono caption (no h2 glow). */
export function TileLabel({ className, children, ...props }: ComponentProps<"h2">) {
  return (
    <h2
      className={cn(
        "text-muted-foreground text-xs font-mono font-normal uppercase tracking-wide text-shadow-none",
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  );
}
